<script>
  import Glossario from './glossario.svelte';
  export let idUnico = 'paragraph-1';
  export let content;
  // export let parCount;

  import { location } from 'svelte-spa-router';

  let linkBegin;
  let linkClose;
  let link;
  let referencia_1;
  let referencia_2;
  let paragrafo_nomal = false;
  let is_ol_ap = false;
  let paragrafo_glossario = false;

  // italico
  let italicoBegin;

  // negrito
  let negritoBegin;
  let negritoEnd;
  let negrito;

  // glossario
  let glossarioBegin;
  let glossarioTitle;
  let glossarioTextoBegin;
  let glossarioEnd;
  let glossarioTexto;

  content = content.replaceAll('[S. l.]', '<i>[S. l.]</i>');
  content = content.replaceAll('In:', '<i>In:</i>');
  content = content.replaceAll('et al.', '<i>et al.</i>');
  content = content.replaceAll('rush', '<i>rush</i>');
  content = content.replaceAll('high', '<i>high</i>');
  content = content.replaceAll('ecstasy', '<i>ecstasy</i>');
  content = content.replaceAll('setting', '<i>setting</i>');
  content = content.replaceAll('Settingx', 'setting');
  content = content.replaceAll(' set ', '<i> set </i>');
  content = content.replaceAll('droog', '<i>droog</i>');
  content = content.replaceAll('{i}', '<i>');
  content = content.replaceAll('{/i}', '</i>');
  content = content.replaceAll('Cannabis', '<i>Cannabis</i>');
  content = content.replaceAll('sativa spp', '<i>sativa spp</i>');
  content = content.replaceAll('sativa L', '<i>sativa L</i>');
  content = content.replaceAll('{amp}', '&');
  content = content.replaceAll('{B}', '<b>');
  content = content.replaceAll('{/B}', '</b>');

  glossarioBegin = content.indexOf('{{glossario}}');
  if (glossarioBegin != -1) {
    glossarioEnd = content.indexOf('{{/glossario}}');
    glossarioTextoBegin = content.indexOf('==');
    if (glossarioTextoBegin != -1) {
      glossarioTitle = content.substring(
        glossarioBegin + '{{glossario}}'.length,
        glossarioTextoBegin - 1
      );
      glossarioTexto = content.substring(glossarioTextoBegin + 3, glossarioEnd);
      new Glossario({
        target: document.querySelector('#viewer'),
        props: {
          title: glossarioTitle,
          texto: glossarioTexto,
          paragrafo: content,
          glossarioBegin: glossarioBegin,
          glossarioEnd: glossarioEnd,
          idUnico: idUnico,
        },
      });
      paragrafo_glossario = true;
    }
  }

  // negritoBegin = content.indexOf('{B}');
  // if (negritoBegin != -1) {
  //   negritoEnd = content.indexOf('{/B}');
  //   negrito = content.substring(negritoBegin + 3, negritoEnd);
  //   content = content.replace(
  //     content.substring(negritoBegin, negritoEnd + 4),
  //     '<b>' + negrito + '</b>'
  //   );
  // }

  linkBegin = content.search('http');

  if (linkBegin != -1) {
    content = content.replaceAll('<i>set</i>', 'set');
    referencia_1 = content.substring(0, linkBegin);

    linkClose = content.search('. Acesso');
    if (linkClose != -1) {
      link = content.substring(linkBegin, linkClose);
      referencia_2 = content.substring(linkClose, content.length);
    } else {
      paragrafo_nomal = true;
    }
  } else {
    if ($location === '/' || Number($location.split('/')[1]) === 1) {
      const regex = /\d\.\d/;
      linkBegin = content.search(regex);
      if (linkBegin != -1) {
        content = content.replace(
          content.substring(linkBegin, linkBegin + 3),
          '<div class="ol_ap">' + content.substring(linkBegin, linkBegin + 3) + '</div>'
        );
        is_ol_ap = true;
      }
    }
    paragrafo_nomal = true;
  }
</script>

{#if !paragrafo_glossario}
  <div class="container" id={idUnico}>
    <p class={is_ol_ap ? 'p_ap' : ''}>
      {#if paragrafo_nomal}
        {@html content}
      {:else}
        {@html referencia_1} <a target="_blank" href={link}>{link}</a>{referencia_2}
      {/if}
    </p>
  </div>
{/if}

<style>
  @media (max-width: 767px) {
  }
</style>
